import { get } from 'lodash';
import { createSelector } from 'reselect';
import {
    domainsByIdSelector,
    domainsIsLoadingSelector
} from './domains-selectors';
import {
    selectedDmarcPassTypeSelector
} from '../../reports/selectors/reports-selectors';
import * as DmarcChartHelpers from '../../reports/components/domain-portfolio/dmarc-chart-helpers';

export const aggDomainsIsLoadingSelector = state => get( state, 'aggDomains.isLoading', false );
export const allIdsInAggDomainsSelector = state => get( state, 'aggDomains.allIds', [] );
export const aggDomainsByIdSelector = state => get( state, 'aggDomains.byId', {} );
export const prevAggDomainsParamsSelector = state => get( state, 'aggDomains.params' );

export const aggDomainsSelector = createSelector(
    allIdsInAggDomainsSelector,
    aggDomainsByIdSelector,
    ( ids, all ) => ids.map( id => all[id] ) );


export const dmarcBubbleChartIsLoadingSelector = createSelector(
    aggDomainsIsLoadingSelector,
    domainsIsLoadingSelector,
    ( aggDomainsIsLoading, domainsIsLoading ) => {
        return aggDomainsIsLoading || domainsIsLoading;
    }
);
export const dmarcBubbleChartSelector = createSelector(
    dmarcBubbleChartIsLoadingSelector,
    aggDomainsByIdSelector,
    domainsByIdSelector,
    selectedDmarcPassTypeSelector,
    ( isLoading, aggDomainsMap, domainMap, dmarcPassType ) => {
        if( isLoading ){
            return [];
        }
        // Agg domains data, but combined with detailed domain info from domain call
        let newChartData = [];
        for( const domainName in domainMap ){
            let defaultRow = {
                domainName,
                totalMailCount: 0
            };

            // We want to have all domains in our list, even if no traffic came from them
            let chartDataRow = { ...defaultRow, ...aggDomainsMap[domainName] };
            chartDataRow.domainName = domainName;
            chartDataRow.policy = get( domainMap[domainName], 'dmarc.policy', 'no_record' );
            chartDataRow.percentAuthorizedPassingDmarc = DmarcChartHelpers
                .percentAuthorizedPassingDmarc( chartDataRow, dmarcPassType );
            chartDataRow.percentAuthorizedSinglePass = DmarcChartHelpers
                .percentAuthorizedPassingDmarc( chartDataRow, 'single' );
            chartDataRow.percentAuthorizedDoublePass = DmarcChartHelpers
                .percentAuthorizedPassingDmarc( chartDataRow, 'double' );
            chartDataRow.friendlyPolicy = DmarcChartHelpers.dmarcPolicyToFriendly( chartDataRow );
            chartDataRow.abuseRate =  DmarcChartHelpers.buildAbuseRate( chartDataRow );
            chartDataRow.colorClass = DmarcChartHelpers.buildColorClass( chartDataRow );
            newChartData.push( chartDataRow );
        }

        return newChartData;
    }
);

